import { render, staticRenderFns } from "./ListaProjetos.vue?vue&type=template&id=17b1e838&scoped=true"
import script from "./ListaProjetos.vue?vue&type=script&lang=js"
export * from "./ListaProjetos.vue?vue&type=script&lang=js"
import style0 from "./ListaProjetos.vue?vue&type=style&index=0&id=17b1e838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b1e838",
  null
  
)

export default component.exports